import React from 'react';

const SummaryItem = ({ label, value }) => (label === "Percentage of tickets solved by Remarkable AI" ?
    <div>
        <h2 className="font-40">{value}</h2>
        <p>{label}</p>
    </div> :
    <div>
        <h5 className="summary-item-label">{label}</h5>
        <h2 className="font-25 mt-0">{value}</h2>
    </div>
);

export default SummaryItem;
